import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=06b54537&scoped=true&"
import script from "./ElementForm.vue?vue&type=script&lang=js&"
export * from "./ElementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b54537",
  null
  
)

export default component.exports